import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "top-oa" }
const _hoisted_2 = { id: "container-info" }
const _hoisted_3 = { id: "title" }
const _hoisted_4 = { id: "infos" }
const _hoisted_5 = { id: "div-autor" }
const _hoisted_6 = { id: "container-tv" }
const _hoisted_7 = { id: "action-buttons" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { id: "container-desc-info" }
const _hoisted_10 = { id: "esquerda" }
const _hoisted_11 = { id: "direita" }
const _hoisted_12 = { id: "h2-recomendado" }
const _hoisted_13 = { id: "h2-tags" }

import { ref, onBeforeMount } from "vue";
import { useRoute } from "vue-router";
import api from "@/services/api";
import MyNavBar from "@/components/MyNavBar.vue";
import MyFooter from "@/components/MyFooter.vue";

interface Post {
  [key: string]: any;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'MyOa',
  setup(__props) {

const theme = ref("light");
const route = useRoute();
const loading = ref(true);
const post = ref<Post | null>(null);
const copySuccess = ref(false);

const copyURL = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    copySuccess.value = true;
    setTimeout(() => {
      copySuccess.value = false;
    }, 2000);
  } catch {
    alert("Não foi possível copiar o link.");
  }
};

const fetchPost = async () => {
  const oaId = route.params.id as string;

  try {
    const { data } = await api.get(`lobjects/${oaId}/?detail=full`);
    post.value = data;
  } catch {
    alert("OA não encontrado");
  } finally {
    loading.value = false;
  }
};
onBeforeMount(fetchPost);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Section = _resolveComponent("Section")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", null, [
      _createVNode(MyNavBar, { theme: theme.value }, null, 8, ["theme"])
    ]),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_router_link, {
        id: "voltar",
        to: "",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.go(-1)), ["prevent"]))
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("div", { id: "icon-arrow-left" }, null, -1),
          _createTextVNode(" Voltar para a busca")
        ])),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(post.value?.title), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Postado por", -1)),
              _createElementVNode("h3", null, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { id: "elipse" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(post.value?.author || "Autor desconhecido"), 1)
              ])
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "line" }, null, -1)),
            _createElementVNode("div", null, [
              _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Nível Escolar Recomendado:", -1)),
              _createElementVNode("h3", null, _toDisplayString(post.value?.schoolLevels?.map((sl) => sl.name).join(", ")), 1)
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "line" }, null, -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h1", null, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { id: "video-tv" }, null, -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(post.value?.languages, (languages) => {
                  return (_openBlock(), _createElementBlock("h2", {
                    key: languages.id
                  }, _toDisplayString(languages.name), 1))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (post.value && post.value.link)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  id: "conteudo",
                  href: post.value.link,
                  target: "_blank"
                }, "Acessar Conteúdo", 8, _hoisted_8))
              : _createCommentVNode("", true),
            _cache[8] || (_cache[8] = _createElementVNode("a", { href: "" }, [
              _createElementVNode("div", { id: "icon-heart" }),
              _createTextVNode(" Adicionar aos Favoritos")
            ], -1)),
            _cache[9] || (_cache[9] = _createElementVNode("a", { href: "" }, [
              _createElementVNode("div", { id: "icon-share" }),
              _createTextVNode(" Compartilhar")
            ], -1))
          ])
        ])
      ])
    ]),
    _createVNode(_component_Section, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[10] || (_cache[10] = _createElementVNode("h1", null, "Descrição", -1)),
            _createElementVNode("p", null, _toDisplayString(post.value?.description), 1)
          ]),
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "separator" }, null, -1)),
          _createElementVNode("div", _hoisted_11, [
            _cache[19] || (_cache[19] = _createElementVNode("h1", null, "Informações Adicionais", -1)),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _cache[11] || (_cache[11] = _createElementVNode("h1", null, "Linguagens:", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(post.value?.languages, (languages) => {
                  return (_openBlock(), _createElementBlock("h2", {
                    key: languages.id
                  }, _toDisplayString(languages.name), 1))
                }), 128))
              ]),
              _createElementVNode("li", null, [
                _cache[12] || (_cache[12] = _createElementVNode("h1", null, "Temporalidade:", -1)),
                _createElementVNode("h2", null, _toDisplayString(post.value?.temporalities?.map((t) => t.name).join(", ")), 1)
              ]),
              _createElementVNode("li", null, [
                _cache[13] || (_cache[13] = _createElementVNode("h1", null, "Séculos:", -1)),
                _createElementVNode("h2", null, _toDisplayString(post.value?.centuries?.map((c) => c.name).join(", ")), 1)
              ]),
              _createElementVNode("li", null, [
                _cache[14] || (_cache[14] = _createElementVNode("h1", null, "Localização:", -1)),
                _createElementVNode("h2", null, _toDisplayString(post.value?.locations?.map((l) => l.name).join(", ")), 1)
              ]),
              _createElementVNode("li", null, [
                _cache[15] || (_cache[15] = _createElementVNode("h1", null, "BNCC:", -1)),
                _createElementVNode("h2", null, _toDisplayString(post.value?.bnccs?.map((bncc) => bncc.description).join(" ")), 1)
              ]),
              _createElementVNode("li", null, [
                _cache[16] || (_cache[16] = _createElementVNode("h1", null, "Nível Escolar Recomendado:", -1)),
                _createElementVNode("h2", _hoisted_12, _toDisplayString(post.value?.school_levels?.map((sl) => sl.name).join(", ")), 1)
              ]),
              _createElementVNode("li", null, [
                _cache[17] || (_cache[17] = _createElementVNode("h1", null, "Classificação Indicativa:", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(post.value?.age_ranges, (ageRange) => {
                  return (_openBlock(), _createElementBlock("h2", {
                    key: ageRange.id
                  }, _toDisplayString(ageRange.name), 1))
                }), 128))
              ]),
              _createElementVNode("li", null, [
                _cache[18] || (_cache[18] = _createElementVNode("h1", null, "Tags:", -1)),
                _createElementVNode("h2", _hoisted_13, _toDisplayString(post.value?.tags?.map((tag) => tag.name).join(", ")), 1)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("section", null, [
      _createVNode(MyFooter)
    ])
  ], 64))
}
}

})